import { render, staticRenderFns } from "./OrdersScheduleLaundryPickup.vue?vue&type=template&id=6633aa11&scoped=true"
import script from "./OrdersScheduleLaundryPickup.vue?vue&type=script&lang=js"
export * from "./OrdersScheduleLaundryPickup.vue?vue&type=script&lang=js"
import style0 from "./OrdersScheduleLaundryPickup.vue?vue&type=style&index=0&id=6633aa11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6633aa11",
  null
  
)

export default component.exports